import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirebaseWebConfig } from "./firebaseConfig";

let app = null;
let auth = null;

export const getFirebaseAuth = () => {
  if (!app) {
    const firebaseConfig = getFirebaseWebConfig();
    if (!firebaseConfig) {
      throw new Error(
        "Firebase is not configured. Set the REACT_APP_FIREBASE_* variables in your .env file."
      );
    }
    app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
  }

  if (!auth) {
    auth = getAuth(app);
  }

  return auth;
};
